export default [
    //新版首页
    {
        path: "/v2/index",
        component: () => import("./views/index")
    },
    //改版首页
    {
        path: "/v3/index",
        redirect: "/v4/index"
        // component: () => import('./views/index/v3')
    },
    //v4首页
    {
        path: "/v4/index",
        component: () => import("./views/index/v4")
    },
    //新版就医
    {
        path: "/v2/jy",
        component: () => import("./views/jy")
    },
    //新版搜索
    {
        path: "/v2/search",
        component: () => import("./views/search.vue")
    },
    //新版体检首页
    {
        path: "/v2/tj",
        // component: () => import('./views/tj')
        component: () => import("./views/tj/2022-11-06")
    },
    //新版体检首页-跳转小程序
    {
        path: "/v2/tj/mini",
        // component: () => import('./views/tj')
        component: () => import("./views/tj/tj-to-mini.vue")
    },
    //新版我的
    {
        path: "/v2/my",
        component: () => import("./views/my")
    },
    //设置页
    {
        path: "/v2/set",
        component: () => import("./views/set")
    },
    //关于我们
    {
        path: "/v2/about",
        component: () => import("./views/about")
    },
    //使用帮助
    {
        path: "/v2/help",
        component: () => import("./views/help")
    },
    //入院办理
    {
        path: "/v2/rybl",
        component: () => import("./views/rybl")
    },
    //入院办理宣教
    {
        path: "/v2/ryblxj",
        component: () => import("./views/ryblxj")
    },
    //推送消息设置
    {
        path: "/v2/notice",
        component: () => import("./views/notice")
    },
    //体检-选择机构
    {
        path: "/v2/tj/org",
        component: () => import("./views/tj/org")
    },
    //体检-选择就诊人
    {
        path: "/v2/tj/compat",
        component: () => import("./views/tj/compat")
    },
    {
        path: "/v2/pk",
        component: () => import("./views/pk")
    },
    {
        path: "/v2/pk/all",
        component: () => import("./views/pk/all")
    },
    {
        path: "/v2/pk/pic",
        component: () => import("./views/pk/pic")
    },
    // 老年病评估
    {
        path: "/v2/senility",
        component: () => import("./views/senility.vue")
    }
].map(item => {
    let component = item.component;
    console.log('-----------', typeof component)
    if (!component) return item;
    item.component = getTpl(component(), item.name || '');
    return item;
});


function getTpl(defaultTpl, name) {
    return () => {
        return defaultTpl;
    };
}



// WEBPACK FOOTER //
// ./src/page/v2/router.js